import React from 'react';

const SofaBed = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24.8 25"
    style={{
      enableBackground: 'new 0 0 24.8 25'
    }}
    xmlSpace="preserve"
    {...props}
  >
    <path
      d="M24.8 16.3c0-.5-.2-1-.6-1.4-.4-.4-.9-.6-1.4-.6h-.2v-.2c0-1.2-.5-2.4-1.3-3.2-.9-.9-2-1.3-3.2-1.3H6.6c-1.2 0-2.4.5-3.2 1.3-.9.9-1.3 2-1.3 3.2v.2h-.2c-1.1 0-1.9.9-1.9 1.9v4.2c0 1.2.9 2.3 2.1 2.4v1.8c0 .2.2.4.4.4s.4-.2.4-.4v-1.7H22v1.7c0 .2.2.4.4.4s.4-.2.4-.4v-1.8c1.2-.2 2.1-1.2 2.1-2.4l-.1-4.1zm-6.6-5.9c1 0 2 .4 2.7 1.1.7.7 1.1 1.7 1.1 2.7v.4c-.6.3-1 1-1 1.7v1c0 .4-.3.7-.7.7h-8v-7.6h5.9zM2.8 14.2c0-1 .4-2 1.1-2.7.7-.7 1.7-1.1 2.7-1.1h4.9V18h-7c-.4 0-.7-.3-.7-.7v-1c0-.7-.4-1.4-1-1.7v-.4zm21.3 6.2c0 1-.8 1.7-1.7 1.7H2.5c-1 0-1.7-.8-1.7-1.7v-4.2c0-.7.5-1.2 1.2-1.2s1.2.5 1.2 1.2v1c0 .8.6 1.4 1.4 1.4h15.7c.8 0 1.4-.6 1.4-1.4v-1c0-.7.5-1.2 1.2-1.2.3 0 .6.1.8.4.2.2.4.5.4.8v4.2z"
      style={{
        fill: '#224251'
      }}
    />
    <path
      d="M14.1 8.2v.5h-2.8v-.4l2-2.6h-1.9v-.5H14v.4l-2 2.6h2.1zm5.1-1.1v.7h-3.7v-.5l2.7-3.6h-2.6V3h3.6v.5l-2.7 3.6h2.7zm5.4-2.2v.8h-4.5v-.6L23.3.8h-3.1V0h4.3v.6l-3.2 4.3h3.3z"
      style={{
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        fill: '#224251'
      }}
    />
  </svg>
);

export default SofaBed;
